<template>
    <div class="faq" ref="pricingFaq">
        <a-collapse accordion :expand-icon-position="'right'" :bordered="false">
            <a-collapse-panel 
                v-for="(item,index) in usePricingFaq" 
                :key="`${item.title}-${index}`"
                :header="item.title"
            >
                <p v-html="item.description" ref="faqDesc" class="faq__description">{{ item.description }}</p>
            </a-collapse-panel>
            <template #expandIcon="props">
                <a-icon :type="props.isActive ? 'minus': 'plus'" />
            </template>
        </a-collapse>
    </div>
</template>

<script>
import {usePricingFaq} from './usePricingFaq'
export default {
    name: 'Faq',
    data() {
        return {
            usePricingFaq,
            iconType: 'plus'
        }
    },
    mounted() {
        this.$refs.pricingFaq.addEventListener('click', (e) => {
            if(e.target.className === 'openCalendly') {
                Calendly.initPopupWidget({
                    url: 'https://calendly.com/teamcrossprom/crossprom-for-your-kickstarter-campaign'
                })
            }
            else return
        })
    },
    beforeDestroy() {
        this.$refs.pricingFaq.removeEventListener('click', () => {})
    },
}
</script>

<style lang="scss" scoped>
.faq {
    &__description {
        font-size: 16px;
        line-height: 28px;
        margin-bottom: 0;
        color: #333333;
    }
}
</style>